import ApiService from "@Src/services/ApiService";
import { HOME_API_ROUTES } from "./Home.api.constant";
import { VideoListRequest, VideoListResponse, TestimonialsListResponse, HomeBoardListResponse, HomeBannerData, HomeBannerListResponse, HomeCmsListResponse, FaqListResponse } from "./Home.api.interface";
import { USE_VIDEO_MOCK_DATA, getMockVideoList } from "@Src/mocks/videoMockData";


// export async function getBannnerimages() { // need to define proper interface
//     return await ApiService.fetchData({
//         url: HOME_API_ROUTES.HOME +  '/' +  HOME_API_ROUTES.BANNER_HOME,
//         method: "get",
//         params:''
//     });
// }

export async function getVideoList(filters: VideoListRequest, isLoggedIn: boolean = true): Promise<VideoListResponse> {
    if (USE_VIDEO_MOCK_DATA) {
        return await getMockVideoList(filters) as VideoListResponse;
    }

    const url = isLoggedIn ? HOME_API_ROUTES.VIDEO_LIST : HOME_API_ROUTES.VIDEO_LIST_HOME;

    return await ApiService.fetchData({
        url: url,
        method: "post",
        data: filters
    });
}

export async function getTestimonialsList(): Promise<TestimonialsListResponse> {
    return await ApiService.fetchData({
        url: HOME_API_ROUTES.TESTIMONIALS_LIST,
        method: "get"
    });
}

export async function getHomeBoardList(): Promise<HomeBoardListResponse> {
    return await ApiService.fetchData({
        url: HOME_API_ROUTES.HOME_BOARD_LIST,
        method: "get"
    });
}

export async function getHomeBannerList(): Promise<HomeBannerListResponse> {
    return await ApiService.fetchData({
        url: HOME_API_ROUTES.HOME_BANNER_LIST,
        method: "get"
    });
}

export async function getHomeCmsList(): Promise<HomeCmsListResponse> {
    return await ApiService.fetchData({
        url: HOME_API_ROUTES.HOME_CMS_LIST,
        method: "get"
    });
}

export async function getFaqList(): Promise<FaqListResponse> {
    return await ApiService.fetchData({
        url: HOME_API_ROUTES.FAQ_LIST,
        method: "get"
    });
}